// src/redux/reducers/registrationReducer.js

import {
  SET_REGISTRATION_STEP,
  SET_REGISTRATION_DATA,
  CLEAR_REGISTRATION,
} from "../actionsFolder/registrationActions";

const initialState = {
  // Use step names for clarity; could also use numbers if preferred
  currentStep: "welcome",
  registrationData: {
    userEmail: "",
    company: "",
    collectionBrand: "",
    systemName: "",
    // any additional data from subsequent steps can be added here
  },
};

const registrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REGISTRATION_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    case SET_REGISTRATION_DATA:
      return {
        ...state,
        registrationData: {
          ...state.registrationData,
          ...action.payload,
        },
      };
    case CLEAR_REGISTRATION:
      return initialState;
    default:
      return state;
  }
};

export default registrationReducer;
